import { UnifiedMonitoringProduct } from '@hakimo-ui/hakimo/types';

export interface ProductConfig {
  urlPath: string;
  linkCopiedMessage: string;
}

export const PRODUCT_CONFIG: Record<UnifiedMonitoringProduct, ProductConfig> = {
  [UnifiedMonitoringProduct.SCAN]: {
    urlPath: 'alarm-groups',
    linkCopiedMessage: 'Alarm group link copied to clipboard',
  },
  [UnifiedMonitoringProduct.REMOTE_GUARDING]: {
    urlPath: 'location-alarms',
    linkCopiedMessage: 'Location alarm link copied to clipboard',
  },
  [UnifiedMonitoringProduct.ENTERPRISE]: {
    urlPath: 'location-alarms',
    linkCopiedMessage: 'Location alarm link copied to clipboard',
  },
};

export function getProductConfig(
  product: UnifiedMonitoringProduct
): ProductConfig {
  return PRODUCT_CONFIG[product];
}
